import { useCallback } from 'react';
import { useGameStore } from '../hooks/useGameStore';

export function Score() {
  const score = useGameStore(useCallback((state) => state.score, []));

  return (
    <div className="bg-secondary-dark w-52 p-3 rounded-full text-center">
      <span className="text-white font-bold text-3xl">{score} p</span>
    </div>
  );
}
